import React, { lazy, Suspense } from "react";
import { FaCheck } from "react-icons/fa6";

const Whywaggexcommonchoice = lazy(
  () => import("./common/Whywaggexcommonchoice"),
);

const LookingforPayroll = lazy(() => import("./common/LookingforPayroll"));
const HomeFaq = lazy(() => import("../../pages/HomeFaq"));

const AppDownloadCard = lazy(() => import("../common/AppDownloadCard"));

const PayrollBanner = lazy(() => import("../common/PayrollBanner"));

const ModernizeHR = lazy(() => import("../common/ModernizeHR"));

import mobile364 from "@/assets/citywise/waggex-payroll-software-chandigarh-hero-all-in-one.webp?w=350&format=webp";
import mobile556 from "@/assets/citywise/waggex-payroll-software-chandigarh-hero-all-in-one.webp?w=950&format=webp";
import { Helmet } from "react-helmet-async";

const Chandigarh = () => {
  const faq1 = [
    {
      title: "What should businesses look for in payroll software?",
      content:
        "Choose payroll software that automates salary processing, attendance, leave management, overtime calculations, payslip generation, and statutory compliance. A connected platform helps reduce manual work, improve accuracy, and simplify monthly payroll operations.",
    },
    {
      title: "Can payroll software manage multiple employee types?",
      content:
        "Yes. Waggex supports office employees, remote teams, field staff, shift workers, and multi-location workforces. Attendance, leave, and payroll are managed together, ensuring accurate salary processing for every employee.",
    },
    {
      title: "Does Waggex automate salary calculations?",
      content:
        "Yes. Waggex automatically calculates salaries using attendance, approved leave, overtime, late arrivals, and payroll rules, helping HR teams reduce manual calculations and payroll errors.",
    },
  ];

  const faq2 = [
    {
      title:
        "Can employees access payroll and HR services through the Staff App?",
      content:
        "Yes. Employees can mark attendance, apply for leave, download payslips, view attendance records, and receive company updates directly through the Waggex Staff App, reducing routine HR queries.",
    },
    {
      title:
        "Is Waggex suitable for startups, SMEs, and established businesses in Chandigarh?",
      content:
        "Absolutely. Waggex is designed for startups, SMEs, healthcare organizations, educational institutions, professional service firms, manufacturers, and enterprises looking to simplify payroll and workforce management from one platform.",
    },
  ];

  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",

      name: "Waggex Payroll Software Chandigarh",
      applicationCategory: "BusinessApplication",
      operatingSystem: "Web, Android, iOS",

      url: "https://www.waggex.com/payroll-software-chandigarh",

      description:
        "Waggex is payroll and HRMS software for Chandigarh businesses, automating salary processing, attendance tracking, leave management, and employee records on one platform.",

      image: "https://www.waggex.com/waggex-payroll-software-logo.png",

      provider: {
        "@type": "Organization",
        name: "Waggex",
        url: "https://www.waggex.com/",
        logo: "https://www.waggex.com/waggex-payroll-software-logo.png",
      },

      featureList: [
        "Payroll software Chandigarh",
        "Attendance management software Chandigarh",
        "Leave and shift management Chandigarh",
        "Face recognition attendance Chandigarh",
        "Employee self-service app",
      ],

      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "INR",
        availability: "https://schema.org/InStock",
      },

      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.8",
        ratingCount: "134",
        bestRating: "5",
        worstRating: "1",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",

      mainEntity: [
        {
          "@type": "Question",
          name: "Which is the best payroll software in Chandigarh?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The right payroll software depends on your business requirements. Waggex helps Chandigarh businesses automate salary processing, attendance tracking, leave management, and payslip generation from one connected platform.",
          },
        },
        {
          "@type": "Question",
          name: "Does Waggex support attendance-based payroll?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Waggex links employee attendance, approved leave, and working hours directly to payroll. Late marks, absences, and overtime are applied automatically without manual cross-checking.",
          },
        },
        {
          "@type": "Question",
          name: "Does Waggex provide mobile attendance?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Employees can mark attendance through the Waggex Staff App using a selfie or GPS-verified location, suitable for office staff, field teams, and remote employees across Chandigarh.",
          },
        },
        {
          "@type": "Question",
          name: "Does Waggex support face recognition attendance?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Waggex offers AI-powered face recognition attendance via the FaceLens app for contactless, secure employee verification without any biometric hardware purchase.",
          },
        },
      ],
    },

    {
      "@context": "https://schema.org",
      "@type": "Organization",

      name: "Waggex",
      url: "https://www.waggex.com/",

      logo: "https://www.waggex.com/waggex-payroll-software-logo.png",

      description:
        "Waggex provides payroll and HRMS software for businesses in Chandigarh and across India.",
      areaServed: {
        "@type": "City",
        name: "Chandigarh",
      },

      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer support",
        availableLanguage: ["English"],
      },

      sameAs: ["https://www.linkedin.com/company/waggex"],
    },

    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",

      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.waggex.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Payroll Software Chandigarh",
          item: "https://www.waggex.com/waggex-payroll-software-logo.png",
        },
      ],
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Payroll Software in Chandigarh | Salary, HRMS & Attendance
        </title>
        <meta
          name="description"
          content="Manage payroll, attendance, leave, and HR with Waggex payroll software in Chandigarh. Automate salary processing, generate payslips, stay compliant, and save time."
        />
        <meta
          name="keywords"
          content="payroll software in Chandigarh,payroll software Chandigarh,HR software for businesses in Chandigarh,attendance management software Chandigarh,HRMS software Chandigarh,online payroll system Chandigarh,employee management software Chandigarh,leave management software Chandigarh,face recognition attendance Chandigarh,payroll software for IT companies Chandigarh,payroll software for service companies Chandigarh"
        />
        <link
          rel="canonical"
          href="https://www.waggex.com/best-payroll-software-in-chandigarh"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      </Helmet>
      <section className="w-full bg-[#d1dfea] overflow-hidden py-10 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-10 mb-20 mt-10">
            {/* Left Content */}
            <div className="text-center lg:text-left">
              {/* Heading */}
              <h1 className="mt-6 text-[#10324F] font-bold uppercase tracking-wide text-xl md:text-[28px] min-h-16">
                Payroll Software For Chandigarh Businesses
              </h1>

              {/* Description */}
              <p className="service-list-item-text py-4 max-w-md sm:max-w-2xl mx-auto">
                From hospitals and educational institutions to consultancies, IT
                firms, and growing SMEs, businesses need payroll software that
                keeps operations running smoothly. Waggex simplifies payroll,
                attendance, leave management, and employee records from one
                platform, helping HR teams save time and improve operational
                efficiency
              </p>

              {/* Buttons */}
              <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <button
                  onClick={() =>
                    (window.location.href = "https://app.waggex.com/signup")
                  }
                  className="w-full sm:w-auto bg-[#10324F] hover:bg-[#10324F] transition-all duration-300 text-white px-14 py-3 rounded-xl shadow-md text-sm sm:text-base font-medium"
                >
                  Start Free Trial
                </button>

                <button
                  onClick={() => (window.location.href = "/contact-us")}
                  className="w-full sm:w-auto border border-[#10324F] text-[#10324F] hover:bg-[#10324F] hover:text-white transition-all duration-300 px-14 py-3 rounded-xl text-sm sm:text-base font-medium"
                >
                  Book a Demo
                </button>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative flex justify-center items-center">
              {/* Phones Image */}
              <picture>
                <source media="(max-width: 637px)" srcSet={mobile364} />

                <img
                  src={mobile556}
                  fetchPriority="high"
                  width={556}
                  height={394}
                  loading="eager"
                  decoding="async"
                  alt="Waggex all in one payroll software Chandigarh showing payroll, attendance, leave, shift, FaceLens attendance and employee management"
                  className="relative object-contain w-159.25 h-112.75 "
                />
              </picture>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Built for Startups, SMEs & Enterprises
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base leading-relaxed">
              Growing businesses need payroll software that keeps payroll,
              attendance, leave management, and employee records organized in
              one place. Waggex helps HR teams reduce manual work, process
              salaries accurately, and manage everyday workforce operations with
              greater confidence
            </p>
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Automated Payroll Processing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift Management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-Based Salary Calculation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>PDF Payslip Generation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>AI Selfie Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee Self-Service App</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>GPS Attendance Tracking</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-Time Notifications</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee Leave Management</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Face Recognition Attendance</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className=" bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Payroll Management Software for Chandigarh Businesses
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base leading-relaxed">
              Manual payroll takes time and increases the risk of salary errors,
              attendance mismatches, and delayed processing. Waggex automates
              payroll calculations, leave deductions, overtime, and employee
              records, helping businesses process salaries accurately and with
              greater confidence
            </p>
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Automated Payroll Processing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift Management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-Based Salary Calculation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>PDF Payslip Generation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>AI Selfie Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee Self-Service App</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>GPS Attendance Tracking</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-Time Notifications</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee Leave Management</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Face Recognition Attendance</span>
              </div>
            </div>
          </div>
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center max-w-5xl mx-auto">
            Employees receive instant notifications when payslips are generated
            and can securely view or download them anytime through the Staff App
            or employee portal
          </p>
        </div>
      </section>
      <section className=" bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Smarter Attendance Management with AI
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Track attendance through AI face recognition, GPS, geo-fencing,
              and mobile check-ins from one platform. Eliminate manual
              registers, improve attendance accuracy, and keep payroll
              calculations reliable
            </p>
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Automated payroll calculation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee salary reports</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-based payroll processing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Payroll history and records</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Overtime and shift salary management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee payroll notifications</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Payslip generation in PDF format</span>
              </div>
            </div>
          </div>
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center max-w-3xl mx-auto leading-loose">
            Connect attendance with payroll and leave management to reduce HR
            effort, improve accuracy, and simplify monthly salary processing
          </p>
        </div>
      </section>

      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Manage Leave & Shifts Without Efficiently Without Errors
            </h2>

            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Automate leave requests, shift scheduling, and approval workflows
              from one platform. Reduce manual coordination, avoid scheduling
              conflicts, and help managers and HR teams handle workforce
              planning more efficiently
            </p>
          </div>

          {/* List */}
          <div className="mt-8 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Yearly leave allocation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Leave approval workflow</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Leave balance tracking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-time leave notifications</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-based leave management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift management</span>
              </div>
            </div>{" "}
          </div>
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center max-w-2xl mx-auto leading-loose">
            Managers can approve or reject leave requests instantly, while
            employees receive real-time updates and leave balances are
            automatically updated without manual intervention
          </p>
        </div>
      </section>
      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Everything Employees Need in One App
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base max-w-5xl mx-auto">
              Give employees instant access to attendance, leave requests,
              payslips, company updates, and other everyday HR services through
              one mobile app. Self-service reduces HR dependency while improving
              employee convenience and response times
            </p>
            <p className="mt-4 text-[#10324F] text-lg">Employee Can:</p>
          </div>
          {/* List */}
          <div className="mt-8 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Mark attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>View attendance history</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Apply for leave </span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Receive notifications</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Download payslips</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Access employee records</span>
              </div>
            </div>
          </div>{" "}
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center">
            Employees can complete routine HR tasks independently, helping HR
            teams spend less time on repetitive requests and more time on
            strategic work
          </p>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              A Payroll Solution for Every Industry
            </h2>

            <p className="mt-4 text-[#10324F] text-lg">
              Designed for teams of every size:
            </p>
          </div>

          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Startups</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Factories</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>SMEs</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Service Companies</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>IT Companies</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Field Workforce Businesses</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Retail Businesses</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Agencies & Consultancies</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Suspense fallback={null}>
        <Whywaggexcommonchoice
          heading="Built to Simplify Payroll & HR Operations"
          description="Managing payroll, attendance, leave requests, and employee records shouldn't require multiple systems or manual spreadsheets. Waggex brings everything together in one connected platform, helping HR teams stay organized and work more efficiently"
          paragraph="Automate routine HR tasks, improve payroll accuracy, reduce administrative effort, and manage your workforce with confidence from one centralized platform"
        />
        <LookingforPayroll
          heading="Ready to Simplify Payroll & HR?"
          subHeading="Book a Free Demo and See Waggex in Action"
          description="Discover how one platform can simplify payroll, attendance, leave management, shifts, and employee records while reducing manual work and improving payroll accuracy"
          features={[
            "AI Attendance Management",
            "Payroll Automation",
            "Employee Self-Service App",
            "GPS & Face Recognition Attendance",
            "Attendance-Based Payroll",
            "Real-Time Notifications",
          ]}
          buttonText="Book Free Demo"
        />
        <HomeFaq
          faq1={faq1}
          faq2={faq2}
          subtitle="Everything you need to know about Waggex payroll software in India"
        />
        {/*  <AppDownloadCard /> */}
        <PayrollBanner
          heading="Let's Simplify Your Payroll Together"
          description="Manage payroll, attendance, leave, shifts, and employee records with one connected platform designed to save time, reduce manual work, and simplify HR"
          buttonText="View HRMS Software"
          buttonLink="https://waggex.com/"
        />
        <AppDownloadCard />
        <ModernizeHR />
      </Suspense>
    </>
  );
};

export default Chandigarh;
